module.exports = __webpack_public_path__ + "static/flags/BI-2eadf098cef352eb8b7e8df5f2b4ae87.gif";